import ActionsTablet from './ActionsTablet';

export default ActionsTablet;
export { ActionsTablet };
